import {
  validEmailExp,
  SupportedLanguage,
  isSupportedLanguage,
  SupportedMarket,
  isSupportedMarket,
} from '@estercare/ester-shared'

export type SingleUserFormDataType = {
  firstName: string
  lastName: string
  email: string
  isManager?: boolean
  language?: SupportedLanguage
  department?: string
  market: SupportedMarket
}

export type ValidationErrors = Record<string, string>

export const validateSingleUserForm = (
  formData: SingleUserFormDataType,
  t: (key: string) => string
): ValidationErrors => {
  const errors: ValidationErrors = {}

  if (!formData.firstName.trim()) {
    errors.firstName = t('common.validation.firstNameRequired')
  }

  if (!formData.lastName.trim()) {
    errors.lastName = t('common.validation.lastNameRequired')
  }

  if (!formData.email.trim()) {
    errors.email = t('common.validation.emailRequired')
  } else if (!validEmailExp.test(formData.email)) {
    errors.email = t('common.validation.invalidEmail')
  }

  if (formData.language && !isSupportedLanguage(formData.language)) {
    errors.language = t('common.validation.invalidLanguage')
  }

  if (!isSupportedMarket(formData.market)) {
    errors.market = t('common.validation.invalidMarket')
  }

  if (formData.department && formData.department.length > 100) {
    errors.department = t('common.validation.departmentTooLong')
  }

  return errors
}

export const hasValidationErrors = (errors: ValidationErrors): boolean => {
  return Object.keys(errors).length > 0
}
